module.exports = __webpack_public_path__ + "img/printerIcon.e25fb96.svg";